import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AirportIconsService } from 'src/app/search-result/services/airport-icons.service';
import { CheckAndUncheckService } from 'src/app/search-result/services/check-and-uncheck.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { AccordionModule } from '../accordion/accordion.module';
import { FareModule } from '../fare/fare.module';
import { ModalModule } from '../modal/modal.module';
import { TitleModule } from '../title/title.module';
import { ExchangeFareDetailComponent } from './exchange-fare-detail/exchange-fare-detail.component';
import { ExchangeFareComponent } from './exchange-fare/exchange-fare.component';
import { ExchangeFlightComponent } from './exchange-flight/exchange-flight.component';
import { FlightContentComponent } from './flight-content/flight-content.component';
import { FlightHeaderTravelComponent } from './flight-header-travel/flight-header-travel.component';
import { FlightsComponent } from './flights/flights.component';
import { SegmentHeaderComponent } from './segment-header/segment-header.component';
import { SegmentInfoComponent } from './segment-info/segment-info.component';
import { InputSubmitModule } from '../input-submit/input-submit.module';
import { FlightsResumeComponent } from './segment-resume-comparision/flights-resume.component';
import { CardFlightModule } from '../card-flight/card-flight.module';
import { WaitTimeBannerModule } from '../wait-time-banner/wait-time-banner.module';
import { InputSwitchModule } from '../input-switch/input-switch.module';
import { SeatMapModule } from '../seat-map/seat-map.module';
import { AlertModule } from '../alert/alert.module';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { FlightSpecialRequestsModule } from '../passengers/flight-special-requests/flight-special-requests.module';

@NgModule({
  declarations: [
    FlightContentComponent,
    FlightHeaderTravelComponent,
    ExchangeFlightComponent,
    SegmentInfoComponent,
    SegmentHeaderComponent,
    FlightsComponent,
    ExchangeFareComponent,
    ExchangeFareDetailComponent,
    FlightsResumeComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TitleModule,
    InputSubmitModule,
    InputSwitchModule,
    WaitTimeBannerModule,
    AccordionModule,
    FareModule,
    FormsModule,
    CardFlightModule,
    ReactiveFormsModule,
    ModalModule,
    SeatMapModule,
    AlertModule,
    PipesModule,
    FlightSpecialRequestsModule
  ],
  exports: [
    FlightsResumeComponent,
    FlightContentComponent,
    FlightHeaderTravelComponent,
    ExchangeFlightComponent,
    ExchangeFareDetailComponent,
    SegmentInfoComponent,
    FlightsComponent
  ],
  providers: [CheckAndUncheckService, AirportIconsService]
})
export class FlightModule {}
